/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
import axios from "axios";
// bootstrap
// import

// react-router components
import { useLocation, Link, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import imgProfile from "../../../assets/images/profile.png";
import imgDD from "../../../assets/images/Icons.png";
// @mui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Container from "@mui/material/Container";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Alert,
  Avatar,
  Badge,
  Button,
  MenuItem,
  Snackbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import logo from "../../../assets/images/SakshamLogo.svg";
// import logo from "../../../assets/images/Samarth - Logo new.svg";
import cross from "../../../assets/images/close-square.svg";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import NotificationsIcon from "@mui/icons-material/Notifications";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import LockResetIcon from "@mui/icons-material/LockReset";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
  navbarHeader,
} from "examples/Navbars/DashboardNavbar/styles";

// Soft UI Dashboard PRO React context
import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

// Images
import team2 from "assets/images/team-2.jpg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
// import masterCard from "assets/images/small-logos/mastercard.png";
import samarthLogo from "assets/sba_images/samarthLogo.svg";
import { Box, Card } from "@mui/material";
import { Modal } from "react-bootstrap";
import Grid from "@mui/material/Unstable_Grid2";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import moment from "moment";
import {
  BoxFAQ,
  BoxFAQHead,
  SubmitButton,
  SubmitButtonClose,
  TabButton,
  TabButtonClick,
} from "./styles";
import alertGif from "../../../assets/gif/alert-gif.gif";
import { BorderStyle } from "@material-ui/icons";
import { border, borderColor } from "@mui/system";

const copy = require("clipboard-copy");

const jpLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="18" viewBox="0 0 13 18" fill="none">
    <path
      d="M4.181 12.5717L6.16674 17.1137C6.22461 17.2436 6.35457 17.3302 6.49903 17.3302C6.64349 17.3302 6.77345 17.2436 6.83117 17.1135L8.81691 12.5716C11.3226 11.6185 12.9979 9.19578 12.9979 6.49895C12.9979 2.91369 10.0842 0 6.49895 0C2.91369 0 0 2.91369 0 6.49895C0 9.19597 1.67537 11.6188 4.18099 12.572L4.181 12.5717ZM6.49904 1.80516C9.08786 1.80516 11.1926 3.91012 11.1926 6.49871C11.1926 7.93923 10.5247 9.31132 9.38728 10.1959C9.34028 10.2357 9.28618 10.2754 9.23556 10.3115C9.18857 10.3476 9.14172 10.3801 9.08747 10.4162C8.32586 10.9215 7.42692 11.1923 6.49896 11.1923C5.56388 11.1923 4.66479 10.9215 3.90305 10.4088C3.87419 10.3943 3.81647 10.3511 3.75859 10.3113C3.70797 10.2752 3.6575 10.2391 3.61051 10.1994C2.47686 9.3113 1.80535 7.94284 1.80535 6.49868C1.80535 3.90986 3.91015 1.80513 6.4989 1.80513L6.49904 1.80516Z"
      fill="black"
    />
    <path
      d="M4.17563 9.72336L4.25512 9.77746L4.266 9.78471L4.30574 9.80995C4.94464 10.2432 5.70274 10.4708 6.49712 10.4708C7.28427 10.4708 8.03876 10.2433 8.68506 9.81358C8.7248 9.78835 8.75729 9.76659 8.79341 9.74135C8.8475 9.69798 8.88725 9.67275 8.91973 9.64389C9.07145 9.52481 9.21213 9.39833 9.34224 9.26113C9.24478 8.67255 8.97036 8.1346 8.54074 7.70498C8.47214 7.63637 8.39991 7.5714 8.32768 7.51367C7.86908 8.00117 7.2193 8.30442 6.49714 8.30442C5.77862 8.30442 5.12869 8.00114 4.66661 7.51727C4.13953 7.95049 3.76766 8.56793 3.64844 9.26835C3.77476 9.3983 3.90835 9.52116 4.0528 9.63298C4.10705 9.67635 4.14314 9.69798 4.17563 9.72336Z"
      fill="black"
    />
    <path
      d="M8.30594 5.77782C8.30594 6.77482 7.49764 7.58313 6.50063 7.58313C5.50362 7.58313 4.69531 6.77482 4.69531 5.77782C4.69531 4.78081 5.50362 3.97266 6.50063 3.97266C7.49764 3.97266 8.30594 4.78081 8.30594 5.77782Z"
      fill="black"
    />
  </svg>
);

const admLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      opacity="0.983"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5078 1.14854C14.2094 1.05284 15.35 2.33409 14.9297 4.99229C14.9945 5.46325 14.9242 5.91639 14.7187 6.35167C14.5116 6.65973 14.3397 6.98785 14.2031 7.33604C14.0741 7.54735 13.9334 7.75046 13.7812 7.94542C13.5647 8.98262 12.9631 9.70135 11.9765 10.1017C10.99 9.70135 10.3884 8.98262 10.1718 7.94542C9.81142 7.44353 9.49896 6.91225 9.23435 6.35167C9.02885 5.91639 8.95853 5.46325 9.02341 4.99229C8.66163 3.76124 8.92722 2.69092 9.82028 1.78136C10.3404 1.44411 10.9029 1.23317 11.5078 1.14854Z"
      fill="black"
    />
    <path
      opacity="0.976"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.82031 8.74219C9.98681 9.70908 10.1743 10.6778 10.3828 11.6484C10.5833 11.3617 10.7942 11.0804 11.0156 10.8047C11.063 10.7655 11.1177 10.7498 11.1797 10.7578C11.2314 11.0301 11.3251 11.2879 11.4609 11.5312C11.3139 12.0772 11.2202 12.6319 11.1797 13.1953C9.19148 13.1967 7.20712 13.1967 5.22656 13.1953C5.42475 12.2993 5.77631 11.4712 6.28125 10.7109C6.54806 10.4095 6.86841 10.1829 7.24219 10.0312C7.95933 9.82341 8.64684 9.54216 9.30469 9.1875C9.51323 9.08044 9.68512 8.93198 9.82031 8.74219Z"
      fill="black"
    />
    <path
      opacity="0.977"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0859 8.74219C14.4669 9.09722 14.9044 9.37064 15.3984 9.5625C15.8288 9.7372 16.2663 9.89348 16.7109 10.0312C17.3935 10.3232 17.8701 10.8154 18.1406 11.5078C18.3966 12.049 18.5918 12.6115 18.7266 13.1953C16.746 13.1967 14.7616 13.1967 12.7734 13.1953C12.7125 12.5954 12.6265 12.0016 12.5156 11.4141C12.6431 11.1877 12.7525 10.9533 12.8438 10.7109C13.0978 11.0168 13.34 11.3293 13.5703 11.6484C13.7927 10.6889 13.9646 9.72009 14.0859 8.74219Z"
      fill="black"
    />
    <path
      opacity="0.99"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.41406 13.4766C9.78909 13.4687 14.1641 13.4766 18.5391 13.5C19.1801 13.6177 19.5395 14.0005 19.6172 14.6484C19.25 16.8203 18.8828 18.9922 18.5156 21.1641C18.4035 21.6355 18.1145 21.9402 17.6484 22.0781C13.8672 22.1094 10.086 22.1094 6.30469 22.0781C5.83861 21.9402 5.54958 21.6355 5.4375 21.1641C5.07033 18.9922 4.70311 16.8203 4.33594 14.6484C4.42225 13.9998 4.78163 13.6092 5.41406 13.4766ZM11.7891 17.2266C12.2807 17.1791 12.4916 17.3979 12.4219 17.8828C12.285 18.1418 12.0741 18.2277 11.7891 18.1406C11.5301 18.0038 11.4442 17.7929 11.5312 17.5078C11.595 17.3896 11.6809 17.2958 11.7891 17.2266Z"
      fill="black"
    />
    <path
      opacity="0.934"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.97651 22.2891C9.97654 22.2812 13.9765 22.2891 17.9765 22.3125C18.1098 22.4821 18.0942 22.6384 17.9296 22.7813C13.9609 22.8125 9.99215 22.8125 6.02338 22.7813C5.85628 22.6305 5.84067 22.4664 5.97651 22.2891Z"
      fill="black"
    />
  </svg>
);

const crmLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="black">
    <path
      d="M11.5298 4.24922C12.3247 4.40401 13.0553 4.79205 13.628 5.36365C14.2007 5.93525 14.5895 6.66441 14.7446 7.45782M11.5298 1C13.1814 1.18312 14.7214 1.9213 15.8972 3.09331C17.0729 4.26533 17.8144 5.80154 18 7.4497M17.1861 13.9319V16.3688C17.1871 16.595 17.1406 16.819 17.0498 17.0262C16.959 17.2335 16.8258 17.4196 16.6588 17.5725C16.4918 17.7255 16.2946 17.8419 16.0799 17.9144C15.8652 17.9869 15.6377 18.0138 15.4119 17.9934C12.9075 17.7218 10.5019 16.8677 8.38831 15.4996C6.42189 14.2525 4.7547 12.5885 3.50516 10.6258C2.12971 8.50667 1.27375 6.09396 1.00661 3.58313C0.986268 3.3585 1.01301 3.1321 1.08514 2.91836C1.15727 2.70461 1.2732 2.5082 1.42555 2.34162C1.5779 2.17504 1.76334 2.04195 1.97005 1.95082C2.17675 1.85969 2.40021 1.81252 2.62619 1.8123H5.06777C5.46274 1.80842 5.84565 1.94802 6.14512 2.20508C6.4446 2.46214 6.64021 2.81911 6.69549 3.20947C6.79854 3.98933 6.98966 4.75506 7.26519 5.49204C7.37469 5.78279 7.39839 6.09876 7.33348 6.40254C7.26857 6.70631 7.11777 6.98515 6.89895 7.20601L5.86535 8.23763C7.02392 10.2713 8.71097 11.9551 10.7485 13.1115L11.7821 12.0798C12.0034 11.8614 12.2828 11.7109 12.5871 11.6461C12.8915 11.5814 13.2081 11.605 13.4994 11.7143C14.2377 11.9893 15.0049 12.1801 15.7863 12.2829C16.1816 12.3386 16.5427 12.5373 16.8008 12.8414C17.0589 13.1454 17.196 13.5335 17.1861 13.9319Z"
      stroke="#000"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const cpLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
    <path
      d="M7.97315 15.0173L9.12316 13.8673C9.26583 13.7246 9.34294 13.5391 9.34294 13.3394C9.34294 13.1397 9.26596 12.9514 9.12316 12.8116C8.98049 12.6689 8.79499 12.5918 8.59532 12.5918C8.40129 12.5918 8.2158 12.666 8.07603 12.8029L6.55514 14.3238C6.55225 14.3267 6.54949 14.3294 6.54371 14.3323L6.53228 14.3438C6.38961 14.4864 6.3125 14.6719 6.3125 14.8716C6.3125 15.0713 6.38948 15.2597 6.53228 15.3994C6.81473 15.6819 7.30842 15.6819 7.59098 15.3994L7.97315 15.0173Z"
      fill="black"
    />
    <path
      d="M7.67278 12.4157C7.67567 12.4128 7.67843 12.4101 7.68421 12.4072L8.2378 11.8536C8.38047 11.7109 8.45759 11.5254 8.45759 11.3257C8.45759 11.1261 8.3806 10.9377 8.2378 10.7979C8.09514 10.6552 7.90964 10.5781 7.70997 10.5781C7.5103 10.5781 7.3219 10.6551 7.18213 10.7979L5.11041 12.8696C4.96774 13.0123 4.89062 13.1978 4.89062 13.3975C4.89062 13.5971 4.96761 13.7855 5.11041 13.9253C5.3901 14.205 5.87511 14.2078 6.15771 13.9338L7.67278 12.4157Z"
      fill="black"
    />
    <path
      d="M3.45009 10.8343L4.97962 9.30475C5.12229 9.16208 5.1994 8.97659 5.1994 8.77692C5.1994 8.57724 5.12242 8.38885 4.97962 8.24908C4.83695 8.10641 4.65145 8.0293 4.45178 8.0293C4.25211 8.0293 4.06372 8.10628 3.92395 8.24908L2.39166 9.77861C2.24899 9.92128 2.17188 10.1068 2.17188 10.3064C2.17188 10.5061 2.24886 10.6945 2.39166 10.8343C2.6854 11.1254 3.15908 11.1254 3.45009 10.8343Z"
      fill="black"
    />
    <path
      d="M6.85615 10.3321C6.99882 10.1894 7.07593 10.0039 7.07593 9.80426C7.07593 9.60459 6.99895 9.41619 6.85615 9.27642C6.71059 9.13087 6.51944 9.05664 6.32831 9.05664C6.13719 9.05664 5.9459 9.13086 5.80048 9.27642L3.60896 11.4679C3.31785 11.7591 3.31785 12.2355 3.60896 12.5266C3.90008 12.8177 4.37655 12.8178 4.66766 12.5266L6.85615 10.3321Z"
      fill="black"
    />
    <path
      d="M10.2432 14.5134L9.71817 13.9883C9.66115 14.0854 9.59836 14.1767 9.5156 14.2594L8.5625 15.2125L9.05331 15.7033C9.36715 16.0201 9.92653 16.0201 10.2433 15.7033C10.403 15.5436 10.4916 15.3324 10.4916 15.1098C10.4916 14.8873 10.4059 14.6789 10.249 14.5192L10.2432 14.5134Z"
      fill="black"
    />
    <path
      d="M1.33858 5.81062L4.76825 2.17513L4.9481 1.98399L3.72966 0.833984L0 4.78897L1.21569 5.93884L1.33858 5.81062Z"
      fill="black"
    />
    <path
      d="M10.3357 5.09631L10.0331 5.40161C9.2227 6.21205 7.9073 6.21205 7.09686 5.40161C6.58033 4.88508 6.58033 4.04612 7.09686 3.52972L7.73323 2.89336C6.91714 2.52816 6.004 2.42818 5.11658 2.61656L1.80354 6.12627C1.65509 7.12218 1.87199 8.14372 2.39706 8.99121L3.53563 7.85264C4.04352 7.34475 4.87114 7.34475 5.379 7.85264C5.60154 8.07518 5.71861 8.35778 5.74709 8.64586C6.23501 8.40046 6.84574 8.47468 7.25379 8.88272C7.49919 9.12812 7.6362 9.45629 7.6362 9.80441C7.6362 9.88139 7.62766 9.9585 7.61334 10.0327C7.97854 10.0042 8.35531 10.124 8.63488 10.4037C8.88028 10.6491 9.01729 10.9773 9.01729 11.3254C9.01729 11.5879 8.94031 11.839 8.79475 12.0531C9.06012 12.093 9.31694 12.2101 9.52242 12.4155C9.76782 12.6609 9.90484 12.9891 9.90484 13.3372C9.90484 13.3515 9.90195 13.3657 9.90195 13.38L10.6439 14.122C10.6468 14.1249 10.6468 14.1249 10.6496 14.1276L11.2574 14.7355C11.577 15.0551 12.1306 15.0551 12.4501 14.7355C12.7783 14.4073 12.7783 13.8766 12.453 13.5484L10.1816 11.277C10.0732 11.1686 10.0732 10.9946 10.1816 10.8861C10.29 10.7777 10.4641 10.7777 10.5726 10.8861L12.9181 13.2315C13.2319 13.5454 13.7969 13.5454 14.1051 13.2315C14.4333 12.9005 14.4333 12.3669 14.1051 12.0388L12.5928 10.5265C12.4844 10.4181 12.4844 10.244 12.5928 10.1355C12.7012 10.0271 12.8752 10.0271 12.9837 10.1355L14.0396 11.1856C14.3563 11.4994 14.9156 11.4994 15.2295 11.1856C15.3893 11.0258 15.4778 10.8146 15.4778 10.5921C15.4778 10.3666 15.3894 10.1555 15.2295 9.99854L14.4077 9.09683L10.3357 5.09631Z"
      fill="black"
    />
    <path
      d="M12.5625 1.14985L16.1892 4.99083V4.99372L16.2947 5.10499L17.5104 3.95498L13.7808 0L12.5625 1.14985Z"
      fill="black"
    />
    <path
      d="M12.1937 1.56866C10.901 1.38027 9.59121 1.81406 8.67251 2.73286L7.48256 3.91992C7.1829 4.21958 7.1829 4.70749 7.48256 5.00714C8.07607 5.60066 9.0406 5.60066 9.63415 5.00714L10.1335 4.50779C10.1878 4.45353 10.2591 4.42792 10.3304 4.42792C10.4018 4.42792 10.4702 4.45354 10.5245 4.50779L14.5965 8.5112C15.4155 7.64941 15.8206 6.49087 15.7208 5.3038L12.1937 1.56866Z"
      fill="black"
    />
  </svg>
);

const jsLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="11" viewBox="0 0 19 11" fill="none">
    <path
      d="M18.5787 4.91457C18.5727 4.89662 18.5644 4.87946 18.5542 4.86348C16.7292 1.36666 15.5234 1.21338 14.7468 1.48111L14.4034 0.927258C14.1447 0.511299 13.7383 0.20852 13.2656 0.0796268C12.793 -0.0492667 12.2892 0.00525299 11.8551 0.232255C11.421 0.459257 11.0887 0.84196 10.925 1.30364C10.7612 1.76531 10.778 2.27184 10.972 2.72165L11.2275 3.32251C11.1163 3.40256 11.016 3.49668 10.9291 3.6025C10.9291 3.22308 10.7783 2.8592 10.5101 2.5909C10.2418 2.32261 9.87788 2.17189 9.49846 2.17189C9.11904 2.17189 8.75515 2.32261 8.48686 2.5909C8.21857 2.8592 8.06785 3.22308 8.06785 3.6025C7.98177 3.4973 7.88291 3.40324 7.77355 3.32251L8.02697 2.72165C8.22468 2.27106 8.24393 1.76221 8.08082 1.29797C7.91771 0.833728 7.58442 0.448736 7.14833 0.220825C6.71223 -0.00708651 6.20587 -0.0609144 5.73161 0.0702238C5.25735 0.201362 4.85057 0.507683 4.59351 0.927258L4.24607 1.48111C3.46946 1.21338 2.26366 1.36666 0.438607 4.86348C-0.0313338 5.75458 -0.128039 6.79586 0.169764 7.75826C0.467568 8.72066 1.13549 9.52534 2.02658 9.99528C2.91768 10.4652 3.95897 10.5619 4.92137 10.2641C5.88377 9.96632 6.68845 9.2984 7.15839 8.40731C7.16192 8.39784 7.16673 8.3889 7.17269 8.38074C7.29532 8.14503 7.40772 7.92022 7.50991 7.70631C7.68458 8.08717 7.96491 8.4099 8.31758 8.63615C8.67026 8.8624 9.08047 8.98267 9.49948 8.98267C9.91849 8.98267 10.3287 8.8624 10.6814 8.63615C11.034 8.4099 11.3144 8.08717 11.489 7.70631C11.5851 7.91068 11.6934 8.12732 11.8099 8.35213C11.8155 8.36123 11.8203 8.37081 11.8242 8.38074C12.282 9.27726 13.0771 9.95522 14.0347 10.2655C14.5089 10.4191 15.0086 10.4778 15.5055 10.4383C16.0024 10.3988 16.4866 10.2618 16.9305 10.0351C17.3744 9.80848 17.7693 9.49662 18.0927 9.11734C18.4161 8.73806 18.6616 8.2988 18.8152 7.82464C18.9688 7.35048 19.0276 6.85071 18.9881 6.35385C18.9485 5.857 18.8115 5.37279 18.5849 4.92888C18.584 4.92369 18.5819 4.91878 18.5787 4.91457ZM5.00225 8.8978C4.70419 9.05686 4.37757 9.15532 4.04125 9.1875C3.70493 9.21968 3.36557 9.18493 3.04275 9.08526C2.71993 8.9856 2.42005 8.82299 2.1604 8.60682C1.90076 8.39065 1.68649 8.1252 1.52997 7.82579C1.37345 7.52638 1.27778 7.19893 1.24847 6.86235C1.21916 6.52577 1.2568 6.18672 1.35921 5.86476C1.46162 5.5428 1.62678 5.24431 1.84516 4.98652C2.06353 4.72873 2.33079 4.51673 2.63153 4.36277C2.99541 4.17007 3.40105 4.06972 3.8128 4.07051C4.38496 4.07106 4.94046 4.26321 5.39067 4.61631C5.84089 4.9694 6.15988 5.4631 6.29677 6.01865C6.43365 6.57419 6.38055 7.15957 6.14592 7.68142C5.91129 8.20326 5.50866 8.63149 5.00225 8.8978ZM9.49846 7.72879C9.31454 7.72879 9.13476 7.67425 8.98183 7.57207C8.82891 7.46989 8.70973 7.32466 8.63934 7.15475C8.56896 6.98483 8.55055 6.79786 8.58643 6.61748C8.62231 6.43709 8.71087 6.2714 8.84092 6.14136C8.97097 6.01131 9.13666 5.92274 9.31704 5.88686C9.49743 5.85098 9.6844 5.8694 9.85431 5.93978C10.0242 6.01016 10.1695 6.12935 10.2716 6.28227C10.3738 6.43519 10.4284 6.61498 10.4284 6.79889C10.4262 7.0441 10.3273 7.27852 10.1531 7.45115C9.97896 7.62377 9.74367 7.72062 9.49846 7.72061V7.72879ZM16.3756 8.8978C16.0775 9.05686 15.7509 9.15532 15.4146 9.1875C15.0783 9.21968 14.7389 9.18493 14.4161 9.08526C14.0933 8.9856 13.7934 8.82299 13.5338 8.60682C13.2741 8.39065 13.0598 8.1252 12.9033 7.82579C12.7468 7.52638 12.6511 7.19893 12.6218 6.86235C12.5925 6.52577 12.6302 6.18672 12.7326 5.86476C12.835 5.5428 13.0001 5.24431 13.2185 4.98652C13.4369 4.72873 13.7041 4.51673 14.0049 4.36277C14.3689 4.17031 14.7744 4.06997 15.1862 4.07051C15.7583 4.07106 16.3138 4.26321 16.764 4.61631C17.2142 4.9694 17.5332 5.4631 17.6701 6.01865C17.807 6.57419 17.7539 7.15957 17.5193 7.68142C17.2846 8.20326 16.882 8.63149 16.3756 8.8978ZM16.6842 5.8506C16.8644 6.19658 16.9189 6.59438 16.8384 6.97607C16.7579 7.35776 16.5473 7.69966 16.2428 7.94338C16.275 7.7044 16.2555 7.46127 16.1855 7.2305C16.1155 6.99972 15.9968 6.78669 15.8373 6.60584C15.6777 6.42499 15.4812 6.28056 15.2609 6.18235C15.0407 6.08413 14.8019 6.03442 14.5608 6.03658C14.2894 6.03591 14.022 6.10188 13.7821 6.22869C13.6889 6.27653 13.6006 6.33334 13.5185 6.39832C13.5339 6.30342 13.5564 6.20983 13.5859 6.11833C13.7166 5.69331 14.0106 5.33754 14.4034 5.12917C14.6427 5.0026 14.9093 4.93663 15.18 4.93705C15.4898 4.93481 15.7942 5.01816 16.0596 5.17792C16.325 5.33767 16.5412 5.56763 16.6842 5.84243V5.8506ZM5.30064 5.8506C5.4821 6.19835 5.53648 6.59853 5.4544 6.98209C5.37231 7.36566 5.15891 7.70853 4.85102 7.95155C4.88444 7.71263 4.86607 7.46932 4.79716 7.23813C4.72826 7.00693 4.61042 6.79326 4.45166 6.61162C4.29289 6.42998 4.09691 6.28462 3.87701 6.1854C3.65712 6.08618 3.41845 6.03543 3.1772 6.03658C2.90652 6.03616 2.63986 6.10212 2.40059 6.22869C2.3074 6.27653 2.2191 6.33334 2.13695 6.39832C2.15101 6.30353 2.17218 6.20994 2.2003 6.11833C2.2662 5.907 2.37326 5.71081 2.51531 5.54104C2.65737 5.37127 2.83162 5.23129 3.02801 5.12917C3.26719 5.00236 3.53391 4.93638 3.80463 4.93705C4.11312 4.93585 4.41597 5.01973 4.6799 5.17945C4.94382 5.33918 5.15861 5.56857 5.30064 5.84243V5.8506Z"
      fill="black"
    />
  </svg>
);

const jfLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path
      d="M5.68264 0.746148C5.21082 1.19652 5.14648 1.45387 5.14648 2.67631V4.07031H6.00433H6.86218V2.998V1.92569H9.86465H12.8671V2.998V4.07031H13.725H14.5828V2.67631C14.5828 1.45387 14.5185 1.19652 14.0467 0.746148C13.532 0.209992 13.4676 0.209992 9.86465 0.209992C6.26169 0.209992 6.19735 0.209992 5.68264 0.746148Z"
      fill="black"
    />
    <path
      d="M0.536156 5.89481C0.150124 6.2594 0 6.64543 0 7.26737C0 8.10377 0.0214462 8.12522 0.814957 8.2539C1.24388 8.31824 1.82293 8.42547 2.08028 8.48981C2.46632 8.55414 2.5521 8.46836 2.61644 7.88931C2.68078 7.24593 2.74512 7.18159 3.4314 7.18159C4.13912 7.18159 4.18201 7.22448 4.24635 7.95365L4.31069 8.72571L6.06928 8.85439C8.32114 9.04741 11.581 9.04741 13.2538 8.87584L14.562 8.72571L14.6263 7.95365C14.6907 7.22448 14.7336 7.18159 15.4413 7.18159C16.1276 7.18159 16.1919 7.22448 16.2562 7.91076L16.3206 8.61848L17.543 8.46836C19.7091 8.21101 19.7305 8.21101 19.7305 7.24593C19.7305 6.64543 19.5804 6.2594 19.1944 5.89481L18.6797 5.35866H9.86526H1.05086L0.536156 5.89481Z"
      fill="black"
    />
    <path
      d="M0 14.1509V18.8905L0.536156 19.4053L1.05086 19.9414H6.84135H12.6318L12.5031 18.8048C12.2887 16.6172 13.3181 14.6442 15.3341 13.4003C16.2562 12.8213 16.5565 12.7569 18.0577 12.7569H19.7305V11.0627C19.7305 9.75445 19.6662 9.41131 19.4517 9.4971C19.2802 9.56143 18.5295 9.66866 17.736 9.75445C16.342 9.90457 16.3206 9.92602 16.2562 10.5909C16.1919 11.1913 16.1276 11.2557 15.4413 11.2557C14.7979 11.2557 14.6907 11.1699 14.6263 10.7195L14.562 10.1834H9.43634H4.31069L4.24635 10.7195C4.18201 11.1699 4.07478 11.2557 3.4314 11.2557C2.74512 11.2557 2.68078 11.1913 2.61644 10.5694C2.5521 9.81879 2.53065 9.81879 0.814957 9.53999L0 9.41131V14.1509Z"
      fill="black"
    />
    <path
      d="M16.5556 14.1724C15.5262 14.4727 14.218 15.8881 13.9177 16.9819C12.9955 20.4347 16.1696 23.4158 19.4937 22.2148L20.4588 21.8716L21.6598 23.0512C22.8608 24.2522 23.2897 24.4452 23.7615 23.9734C24.2333 23.5015 24.0403 23.0726 22.8393 21.8716L21.6598 20.6706L22.0029 19.7056C22.6678 17.8397 22.0029 15.738 20.373 14.6657C19.4508 14.0438 17.6922 13.8293 16.5556 14.1724ZM19.8154 16.4886C20.373 17.0677 20.4803 17.325 20.4803 18.2258C20.4803 19.148 20.373 19.3839 19.7725 19.9844C18.7646 21.0138 17.2633 21.0138 16.2554 19.9844C15.6549 19.3839 15.5476 19.148 15.5476 18.2472C15.5476 17.132 16.0838 16.2742 17.0489 15.8452C17.8424 15.5021 19.1077 15.7809 19.8154 16.4886Z"
      fill="black"
    />
  </svg>
);

function DashboardNavbar({ absolute, light, isMini }) {
  const registerID = sessionStorage.getItem("register_id");
  const [imgNew, setImgNew] = useState("");
  const [data, setData] = useState([]);
  const [step, setStep] = useState(0);
  const [datakeys, setDatakeys] = useState([]);
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;
  console.log("mininav ", controller.miniSidenav);
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const matchsm = useMediaQuery("(max-width:767px)");
  const [anchorEl, setAnchorEl] = useState(null);
  const [reset, setReset] = useState(false);
  const [copyPassword, setCopyPassword] = useState({
    value: "",
    copied: false,
  });
  const [show, Setshow] = useState(false);
  const [showpassword, Setshowpassword] = useState(false);
  const [displayPassword, setDisplayPassword] = useState("");
  const [fb, setFb] = useState("");
  const [alertshow, setAlertshow] = useState(false);
  const [faq, setFaq] = useState([
    {
      id: 1,
      title: "What is Saksham Rojgar Sathi (SRS)?",
      message:
        "Saksham Rojgar Sathi (SRS) is part of the Government of India's Saksham Project, which aims to tackle unemployment. SRS is a community for job agencies called Placement Service Providers (PSPs). It helps PSPs use smart technology to find the right jobs for people, without companies directly involved.",
    },
    {
      id: 2,
      title: "How can my agency benefit from joining SRS?",
      message:
        "By joining SRS, your agency can benefit in various ways: 1. Influence policy-making affecting the recruitment sector. 2. Access diverse job opportunities from reputable organizations. 3. Network with industry peers, government officials, and stakeholders. 4. Earn financial rewards for successful placements. 5. Ensure transparency in the recruitment process.",
    },
    {
      id: 3,
      title: "What types of opportunities are available through SRS?",
      message:
        "SRS provides access to job requirements across various sectors and industries sourced from reputable organizations associated with the Saksham project. These opportunities span a wide range of positions, catering to different skill sets and experiences.",
    },
    {
      id: 4,
      title: "How does SRS ensure transparency in the recruitment process?",
      message:
        "SRS prioritizes transparency and accountability by providing a user-friendly portal for Placement Service Providers (PSPs) to input candidate information. Real-time updates on candidate progress are offered, ensuring transparency at every stage of the recruitment process.",
    },
    {
      id: 5,
      title: "What financial incentives are available for PSPs through SRS?",
      message:
        "PSPs receive financial rewards for every successful placement made through the SRS platform. These incentives serve as an additional source of revenue for agencies and recognize their contribution to the placement process.",
    },
    {
      id: 6,
      title: "Is SRS certified by the Government of India?",
      message:
        "Yes, empaneled agencies under SRS receive a Government of India certificate, enhancing their credibility and trustworthiness in the industry. This certification validates their participation in the initiative and their commitment to fair and transparent recruitment practices.",
    },
    {
      id: 7,
      title: "How can my agency participate in policy-making discussions through SRS?",
      message:
        "Participating in policy-making discussions through SRS involves attending bi-annual meetings where PSPs have the opportunity to contribute their insights and experiences. These meetings provide a platform for PSPs to collaborate with the Government of India in shaping the recruitment landscape.",
    },
    {
      id: 8,
      title: "What support does SRS offer to PSPs for overcoming challenges in recruitment?",
      message:
        "SRS offers personalized support to PSPs, guiding them in overcoming challenges and fostering their business growth journey as trusted partners. This support may include training, resources, and expert advice tailored to the specific needs of each agency.",
    },
    {
      id: 9,
      title: "How are mandates distributed to PSPs through the SRS platform?",
      message:
        "PSPs receive mandates from associated companies through the SRS platform, expanding their business opportunities. These mandates are distributed based on the agency's profile, expertise, and past performance, ensuring a fair and efficient allocation process.",
    },
    {
      id: 10,
      title: "Can PSPs track the progress of their candidates in real-time through the SRS portal?",
      message:
        "Yes, PSPs can track the progress of their candidates in real-time through the SRS portal. The portal offers updates on candidate status, interview schedules, and placement outcomes, providing PSPs with visibility and control over the recruitment process.",
    },
    {
      id: 11,
      title: "How does SRS ensure fair practices in the recruitment ecosystem?",
      message:
        "SRS aims to simplify the recruitment process and promote fairness and transparency within the ecosystem. This includes implementing standardized procedures, providing equal opportunities to all candidates, and enforcing ethical guidelines for PSPs and employers participating in the platform.",
    },
  ]);
  const [id, setId] = useState(0);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertshow(false);
  };

  const [anchorE2, setAnchorE2] = useState(null);
  const [modalHeight, setModalHeight] = useState(false);
  const open1 = Boolean(anchorE2);
  const handleClick1 = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorE2(null);
    setModalHeight(false);
    setStep(0);
    setId(0);
    setShowList(true);
    setTextId("");
    setTextOpen(false);
  };

  //.............Engage suggestions Function ..........
  const [engageArr, setEngageArr] = useState([]);
  const [showList, setShowList] = useState(true);
  const [showId, setShowId] = useState("");
  const [textOpen, setTextOpen] = useState(false);
  const [textId, setTextId] = useState("");

  const smallText = (text) => {
    if (text.length > 35) {
      return text.substring(0, 35) + "...";
    } else {
      return text;
    }
  };

  const fetchSuggestion = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/get_cp_grievance`,
        {
          params: {
            cpid: sessionStorage.getItem("register_id"),
          },
        }
      )
      .then((res) => {
        setEngageArr(res.data["CP_Grievance"]?.map((el, i) => ({ text: el, id: i })));
        console.log(engageArr, "eee");
      });
  };
  useEffect(() => {
    fetchSuggestion();
  }, []);
  const SubmitFb = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/cp_grievance`,
        {
          cpid: sessionStorage.getItem("register_id"),
          grievance: fb,
        }
      );
      const data = await res.data;
      setAlertshow(true);
      setFb("");
      setShowList(true);
      fetchSuggestion();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);
  const navigate = useNavigate();
  // const [iconState, setIconState] = useState(true);
  // const IconClick = () => {
  //   setMiniSidenav(dispatch, iconState);
  // };
  // IconClick();
  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/login");
  };
  const jpId = sessionStorage.getItem("register_id");
  const [jpLogo, setJPLogo] = useState("");

  const showAlert = () =>
    Swal.fire({
      position: "top",
      icon: "success",
      text: "Download successfull",
      showConfirmButton: false,
      timer: 1500,
    }).then(() => {
      Setshow(false);
      Setshowpassword(false);
      handleClose();
      handleLogout();
      // navigate("/super-admins-list-page");
    });
  const downloadfile = () => {
    const element = document.createElement("a");
    const file = new Blob(
      [`Auto Generate Password : ${showpassword ? displayPassword : copyPassword.value}`],
      {
        type: "text/plain",
      }
    );
    element.href = URL.createObjectURL(file);
    element.download = getFileName();
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    setTimeout(() => {
      showAlert();
    }, 5000);
  };
  const getFileName = () => {
    let d = new Date();
    let dformat = `${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;
    return "authentication_" + dformat + ".txt";
  };

  const FetchNotifications = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/notification/notification`,
        {
          params: {
            counid: sessionStorage.getItem("register_id"),
          },
        }
      );
      const data = await res.data;
      setData(
        data
          ?.map((v) => {
            return {
              id: v.id,
              image:
                v.receiver_type === "JP"
                  ? jpLogo
                  : v.receiver_type === "SA"
                  ? admLogo
                  : v.receiver_type === "CRM"
                  ? crmLogo
                  : v.receiver_type === "CP"
                  ? cpLogo
                  : v.receiver_type === "JobFair"
                  ? jfLogo
                  : v.receiver_type === "ADM"
                  ? admLogo
                  : "",
              message: v.notification,
              key: v.receiver_type,
              read: v.read,
              notification_type: v.notification_type,
              timestamp: v.timestamp ? moment(v.timestamp).format("DD-MM-YYYY HH:mm:ss") : "",
              notification_to: v.notification_to,
            };
          })
          .sort((a, b) => a?.timestamp - b?.timestamp)
          .reverse()
      );
      setDatakeys(data?.map((v) => v.id));
    } catch (err) {
      console.log(err);
    }
  };

  const ReadNotification = async (id) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/notification/notification`,
        {
          ids: [id],
        }
      );
      const data = await res.data;
      FetchNotifications();
    } catch (err) {
      console.log(err);
    }
  };

  const DeleteAllNotification = async (id) => {
    const data = {
      ids: [id],
    };
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/notification/notification`,
        { data }
      );
      const datares = await res.data;
      FetchNotifications();
    } catch (err) {
      console.log(err);
    }
  };

  const DeleteAllNotifications = async (id) => {
    const data = {
      ids: datakeys,
    };
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/notification/notification`,
        { data }
      );
      const datares = await res.data;
      FetchNotifications();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchNotifications();
  }, []);

  const jpDetailsNew = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/channelpartner/register`,
        {
          params: {
            cpid: sessionStorage.getItem("register_id"),
          },
        }
      );
      setImgNew(res?.data?.["Developer Message"]?.org_logo);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    jpDetailsNew();
  }, []);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        image={<img src={team2} alt="person" />}
        title={["New message", "from Laur"]}
        date="13 minutes ago"
        onClick={handleCloseMenu}
      />
      <NotificationItem
        image={<img src={logoSpotify} alt="person" />}
        title={["New album", "by Travis Scott"]}
        date="1 day"
        onClick={handleCloseMenu}
      />
      <NotificationItem
        color="secondary"
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            payment
          </Icon>
        }
        title={["", "Payment successfully completed"]}
        date="2 days"
        onClick={handleCloseMenu}
      />
    </Menu>
  );

  const current = new Date();
  const date = `${("0" + current.getDate()).slice(-2)}/${("0" + (current.getMonth() + 1)).slice(
    -2
  )}/${current.getFullYear()}`;
  const time =
    `${current.getHours() < 10 ? "0" + current.getHours() : current.getHours()}` +
    ":" +
    `${current.getMinutes() < 10 ? "0" + current.getMinutes() : current.getMinutes()}`;
  const day = current.getDay();
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const jpDetails = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/jobprovider/dashboard/fetch/org/details`, {
        params: {
          org_id: jpId,
        },
      })
      .then((res) => {
        console.log("navbar:", res.data["JobProvider_List"]);
        setJPLogo(res.data["JobProvider_List"][0].org_logo);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  // useEffect(() => {
  //   jpDetails();
  // }, []);
  const registrationForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object().shape({
      password: Yup.string()
        .min(8, "Password must be 8 characters long")
        .matches(/[0-9]/, "Password requires a number")
        .matches(/[a-z]/, "Password requires a lowercase letter")
        .matches(/[A-Z]/, "Password requires an uppercase letter")
        .matches(/[^\w]/, "Password requires a special charator"),
      confirm_password: Yup.string()
        .required("Please enter confirm password")
        .oneOf([Yup.ref("password"), null], "Password must match"),
    }),
    onSubmit: (values) => {
      delete values.confirm_password;
      setDisplayPassword(values.password);
      setCopyPassword({ ...copyPassword, value: values.password });
      axios
        .patch(
          `${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/quickresetpassword`,
          //   { ...values, role_id: "SA",
          //   //  creator_role: "SA",
          //    creator_role: roleId,
          //    createdby: registerID }
          {
            modifier_id: registerID,
            updatedby: registerID,
            password: values.password,
          },
          {
            // headers: {
            //     Authorization:  `Bearer ${token}` ,
            // },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: "Updated",
              text: "Password changed successfully",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              setReset(false);
              Setshow(true);
              // navigate("/super-admins-list-page");
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // alert('Error message',err);
          Swal.fire({
            icon: "error",
            title: "",
            text: err["message"],
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            // navigate("/super-admins-list-page");
          });
        });
    },
  });
  return (
    // <AppBar
    //   position={absolute ? "absolute" : navbarType}
    //   color="inherit"
    //   sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    // >
    //   <Toolbar sx={(theme) => navbarContainer(theme)}>
    //     <SoftBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
    //       <Icon fontSize="medium" sx={navbarDesktopMenu} onClick={handleMiniSidenav}>
    //         {miniSidenav ? "menu_open" : "menu"}
    //       </Icon>
    //       {/* <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} /> */}
    //     </SoftBox>
    //     {isMini ? null : (
    //       <SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
    //         {/* <SoftBox pr={1}>
    //           <SoftInput
    //             placeholder="Type here..."
    //             icon={{ component: "search", direction: "left" }}
    //           />
    //         </SoftBox> */}
    //         <SoftBox color={light ? "white" : "inherit"}>
    //           <Link to="/authentication/sign-in/basic">
    //             <IconButton sx={navbarIconButton} size="small">
    //               <Icon
    //                 sx={({ palette: { dark, white } }) => ({
    //                   color: light ? white.main : dark.main,
    //                 })}
    //               >
    //                 account_circle
    //               </Icon>
    //               <SoftTypography
    //                 variant="button"
    //                 fontWeight="medium"
    //                 color={light ? "white" : "dark"}
    //               >
    //                 Sign in
    //               </SoftTypography>
    //             </IconButton>
    //           </Link>
    //           {/* <IconButton
    //             size="small"
    //             color="inherit"
    //             sx={navbarMobileMenu}
    //             onClick={handleMiniSidenav}
    //           >
    //             <Icon className={light ? "text-white" : "text-dark"}>
    //               {miniSidenav ? "menu_open" : "menu"}
    //             </Icon>
    //           </IconButton>
    //           <IconButton
    //             size="small"
    //             color="inherit"
    //             sx={navbarIconButton}
    //             onClick={handleConfiguratorOpen}
    //           >
    //             <Icon>settings</Icon>
    //           </IconButton>
    //           <IconButton
    //             size="small"
    //             color="inherit"
    //             sx={navbarIconButton}
    //             aria-controls="notification-menu"
    //             aria-haspopup="true"
    //             variant="contained"
    //             onClick={handleOpenMenu}
    //           >
    //             <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
    //           </IconButton> */}

    //           {/* logout button */}
    //           {renderMenu()}
    //         </SoftBox>
    //       </SoftBox>
    //     )}
    //   </Toolbar>
    // </AppBar>
    <>
      <Box>
        <AppBar
          //position={absolute ? "fixed" : navbarType}
          position="fixed"
          elevation={0}
          sx={{ background: "#FFFFFF", color: "#000000" }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex" }}>
              <SoftBox
                color="inherit"
                mb={{ xs: 1, md: 0 }}
                sx={(theme) => navbarRow(theme, { isMini })}
              >
                <Icon fontSize="medium" sx={navbarDesktopMenu} onClick={handleMiniSidenav}>
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
                {/* <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} /> */}
              </SoftBox>

              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{ display: { xl: "none" }, mr: 2 }}
                onClick={handleMiniSidenav}
              >
                <MenuIcon />
              </IconButton>

              <SoftBox sx={{ flexGrow: 0.8, display: { xs: "block", md: "block" } }} py="10px">
                <img src={logo} style={{ width: "60px", marginRight: "15px" }} />
                {/* <SoftBox componenet ="img" src={logo}></SoftBox> */}
                {/*<img src={jpLogo} style={{ width: "120px", height: "53px" }}></img>*/}
              </SoftBox>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#000000",
                  m: 2,
                }}
              >
                {window.location.host.split(".")[0] === "srslogin" &&
                sessionStorage.getItem("cp_type") !== "Vakrangee" &&
                sessionStorage.getItem("cp_type") !== "Skilling Partner"
                  ? "Saksham Rojgar Sathi"
                  : window.location.host.split(".")[0] === "mysbalogin" &&
                    sessionStorage.getItem("cp_type") !== "Vakrangee" &&
                    sessionStorage.getItem("cp_type") !== "Skilling Partner"
                  ? "Swavalamban Rojgar Sathi"
                  : sessionStorage.getItem("cp_type") === "Vakrangee"
                  ? "Vakrangee"
                  : sessionStorage.getItem("cp_type") === "Skilling Partner"
                  ? "Training Partner"
                  : "Swavalamban Rojgar Sathi"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "center" }}>
              {sessionStorage.getItem("cp_type") !== "Skilling Partner" && (
                <SoftBox
                  sx={{
                    marginRight: "8px",
                    display: "flex",
                    // justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Badge
                    badgeContent={
                      // dataLength
                      //   ? data?.filter((v) => v.read === 0)?.length === 0
                      //     ? ""
                      //     : data?.filter((v) => v.read === 0)?.length
                      //   : ""
                      data?.filter((v) => v.read === 0)?.length !== 0
                        ? data?.filter((v) => v.read === 0)?.length
                        : ""
                    }
                    sx={{ color: "#3B5092", cursor: "pointer" }}
                    onClick={(event) => {
                      handleClick1(event);
                      // setDataLength(false);
                    }}
                    size="small"
                    aria-controls={open1 ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open1 ? "true" : undefined}
                  >
                    {/* <NotificationsIcon color="black" /> */}
                    <img src={alertGif} alt="alert-gif" width="35px" height="35px" />
                  </Badge>

                  <Menu
                    anchorEl={anchorE2}
                    id="account-menu"
                    open={open1}
                    onClose={handleClose1}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                          m: 0,
                          p: 0,
                        },
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    <Box sx={{ width: "350px", height: "100%", p: 0, m: 0 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        {step === 0 ? (
                          <TabButton>Notifications</TabButton>
                        ) : (
                          <TabButtonClick onClick={() => setStep(0)}>Notifications</TabButtonClick>
                        )}

                        {step === 1 ? (
                          <TabButton>{"What's New"}</TabButton>
                        ) : (
                          <TabButtonClick
                            onClick={() => {
                              setStep(1);
                              setModalHeight(false);
                            }}
                          >
                            {"What's New"}
                          </TabButtonClick>
                        )}

                        {step === 2 ? (
                          <TabButton>FAQ</TabButton>
                        ) : (
                          <TabButtonClick
                            onClick={() => {
                              setStep(2);
                              setModalHeight(false);
                            }}
                          >
                            FAQ
                          </TabButtonClick>
                        )}

                        {step === 3 ? (
                          <TabButton>Engage</TabButton>
                        ) : (
                          <TabButtonClick
                            onClick={() => {
                              setStep(3);
                              setModalHeight(false);
                            }}
                          >
                            Engage
                          </TabButtonClick>
                        )}
                      </Box>

                      {step === 0 ? (
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, p: 1 }}>
                          <SoftTypography fontSize="15px" fontWeight="medium">
                            Notifications
                          </SoftTypography>

                          {data?.length !== 0 ? (
                            <SoftTypography
                              fontSize="15px"
                              fontWeight="medium"
                              color="#3B5092"
                              sx={{ "&:hover": { cursor: "pointer" } }}
                              onClick={() => DeleteAllNotifications()}
                            >
                              <u style={{ color: "#3B5092", "&:hover": { cursor: "pointer" } }}>
                                Clear all
                              </u>
                            </SoftTypography>
                          ) : null}
                        </Box>
                      ) : null}

                      <Box
                        sx={{
                          height: modalHeight
                            ? step === 0
                              ? "480px"
                              : "528px"
                            : step === 0
                            ? "320px"
                            : "368px",
                          overflow: "auto",
                        }}
                      >
                        {step === 0 ? (
                          <>
                            {data.map((text) => {
                              return (
                                <Box
                                  key={text.id}
                                  sx={{
                                    background:
                                      text.read === 0
                                        ? "rgb(244, 248, 250)"
                                        : text.read === 1
                                        ? "#FFFFFF"
                                        : "rgb(244, 248, 250)",
                                    width: "100%",
                                    p: 1,
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    borderBottom: "0.5px solid grey",
                                  }}
                                  onClick={() => ReadNotification(text.id ? text.id : "")}
                                >
                                  <Box
                                    sx={{
                                      height: "35px",
                                      width: "35px",
                                      background: "rgb(244, 248, 250)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      borderRadius: "50%",
                                      border: "1px solid grey",
                                    }}
                                  >
                                    {text.image}
                                  </Box>

                                  <Box sx={{ m: 1, width: "260px" }}>
                                    <SoftTypography fontSize="13px" fontWeight="normal" mb={0.75}>
                                      {text.message}
                                    </SoftTypography>

                                    <SoftTypography
                                      fontSize="12px"
                                      fontWeight="normal"
                                      color="grey"
                                    >
                                      {text.timestamp}
                                    </SoftTypography>
                                  </Box>

                                  <Box
                                    sx={{
                                      height: "35px",
                                      width: "35px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <IconButton
                                      onClick={() => DeleteAllNotification(text.id ? text.id : "")}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                </Box>
                              );
                            })}
                          </>
                        ) : step === 2 ? (
                          <>
                            {faq.map((v, i) => {
                              return (
                                <BoxFAQ key={v.id}>
                                  <BoxFAQHead onClick={() => setId(id === "" ? i : "")}>
                                    {v.title}

                                    {i === id ? (
                                      <KeyboardArrowUpIcon fontSize="medium" />
                                    ) : (
                                      <KeyboardArrowDownIcon fontSize="medium" />
                                    )}
                                  </BoxFAQHead>

                                  {i === id ? v.message : null}
                                </BoxFAQ>
                              );
                            })}
                          </>
                        ) : step === 3 ? (
                          <Box height="100%">
                            {engageArr.length > 0 && showList ? (
                              <Box m={1}>
                                <SoftBox
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    backgroundColor: "#cce6ff94",
                                    py: 1,
                                    my: 1,
                                    border: "2px",
                                    borderStyle: "dashed",
                                    borderColor: "#a4d3d0",
                                  }}
                                >
                                  <SoftBox
                                    sx={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "center",
                                      flexDirection: "column",
                                      gap: "5px",
                                    }}
                                    // onClick={() => setShowList(false)}
                                  >
                                    <SoftBox
                                      sx={{
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                      onClick={() => setShowList(false)}
                                    >
                                      <svg
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                      >
                                        <rect
                                          width="30"
                                          height="30"
                                          fill="url(#pattern0_4087_55106)"
                                        />
                                        <defs>
                                          <pattern
                                            id="pattern0_4087_55106"
                                            patternContentUnits="objectBoundingBox"
                                            width="1"
                                            height="1"
                                          >
                                            <use
                                              xlinkHref="#image0_4087_55106"
                                              transform="scale(0.0078125)"
                                            />
                                          </pattern>
                                          <image
                                            id="image0_4087_55106"
                                            width="128"
                                            height="128"
                                            xlinkHref="data:image/png;base64,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"
                                          />
                                        </defs>
                                      </svg>
                                    </SoftBox>
                                    <SoftTypography fontSize="15px" fontWeight="400">
                                      Add Suggestion
                                    </SoftTypography>
                                  </SoftBox>
                                </SoftBox>
                                {engageArr.map((v, i) => {
                                  return (
                                    <SoftBox
                                      my={1}
                                      key={i}
                                      p={1}
                                      sx={{
                                        backgroundColor: "#cce6ff94",
                                        borderRadius: 1,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                      }}
                                    >
                                      {textOpen && v.id == textId ? (
                                        v.text
                                      ) : (
                                        <p>{smallText(v.text)}</p>
                                      )}
                                      {v.text.length > 35 && (
                                        <SoftBox
                                          pt={0.5}
                                          onClick={() => {
                                            setTextId(v.id);
                                            setTextOpen(!textOpen);
                                          }}
                                        >
                                          {textOpen && v.id == textId ? (
                                            <SoftBox
                                              sx={{ cursor: "pointer" }}
                                              onClick={() => {
                                                setTextId(v.id);
                                              }}
                                            >
                                              <svg
                                                width="15"
                                                height="8"
                                                viewBox="0 0 15 8"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M14.8 7.8045C14.7367 7.86648 14.6615 7.91564 14.5788 7.94919C14.496 7.98273 14.4073 8 14.3177 8C14.2281 8 14.1394 7.98273 14.0566 7.94919C13.9738 7.91564 13.8986 7.86648 13.8353 7.8045L7.49992 1.60948L1.16451 7.8045C1.03658 7.92958 0.863075 7.99985 0.682156 7.99985C0.501237 7.99985 0.327728 7.92958 0.199799 7.8045C0.0718697 7.67942 3.56634e-09 7.50978 0 7.3329C-3.56634e-09 7.15601 0.0718697 6.98637 0.199799 6.86129L7.01756 0.195499C7.08088 0.133522 7.15608 0.0843566 7.23884 0.0508115C7.32161 0.0172663 7.41033 0 7.49992 0C7.58952 0 7.67824 0.0172663 7.761 0.0508115C7.84377 0.0843566 7.91896 0.133522 7.98228 0.195499L14.8 6.86129C14.8634 6.9232 14.9137 6.99672 14.948 7.07764C14.9823 7.15856 15 7.2453 15 7.3329C15 7.4205 14.9823 7.50724 14.948 7.58816C14.9137 7.66908 14.8634 7.74259 14.8 7.8045Z"
                                                  fill="black"
                                                />
                                              </svg>
                                            </SoftBox>
                                          ) : (
                                            <SoftBox
                                              sx={{ cursor: "pointer" }}
                                              onClick={() => {
                                                setTextId("");
                                              }}
                                            >
                                              <svg
                                                width="15"
                                                height="8"
                                                viewBox="0 0 15 8"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M0.199955 0.195498C0.263273 0.133522 0.338468 0.0843554 0.421233 0.0508103C0.504 0.0172653 0.592716 0 0.682312 0C0.771908 0 0.860627 0.0172653 0.943393 0.0508103C1.02616 0.0843554 1.10135 0.133522 1.16467 0.195498L7.50008 6.39052L13.8355 0.195498C13.9634 0.0704207 14.1369 0.000152588 14.3178 0.000152588C14.4988 0.000152588 14.6723 0.0704207 14.8002 0.195498C14.9281 0.320575 15 0.490217 15 0.667103C15 0.843989 14.9281 1.01363 14.8002 1.13871L7.98244 7.8045C7.91912 7.86648 7.84392 7.91564 7.76116 7.94919C7.67839 7.98273 7.58967 8 7.50008 8C7.41048 8 7.32176 7.98273 7.239 7.94919C7.15623 7.91564 7.08104 7.86648 7.01772 7.8045L0.199955 1.13871C0.136565 1.0768 0.086278 1.00328 0.0519686 0.922363C0.0176582 0.841442 0 0.754702 0 0.667103C0 0.579504 0.0176582 0.492764 0.0519686 0.411843C0.086278 0.330922 0.136565 0.257405 0.199955 0.195498Z"
                                                  fill="black"
                                                />
                                              </svg>
                                            </SoftBox>
                                          )}
                                        </SoftBox>
                                      )}
                                    </SoftBox>
                                  );
                                })}
                              </Box>
                            ) : !showList ? (
                              <Box sx={{ p: 1 }}>
                                <SoftBox
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    py: 1,
                                  }}
                                >
                                  <SoftTypography
                                    sx={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      color: "#666E80",
                                      // pt: 1,
                                      // pb: 1,
                                    }}
                                  >
                                    {/* Enter your feedback */}
                                    Share you thoughts or suggestions
                                  </SoftTypography>
                                  {/* <SoftBox
                                  sx={{
                                    height: "33px",
                                    backgroundColor: "#3B5092",
                                    borderRadius: "2px",
                                    cursor: "pointer",
                                  }}
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                                  width="40px"
                                  onClick={() => setShowList(true)}
                                >
                                  <SoftBox sx={{ color: "#FFF" }}>x</SoftBox>
                                </SoftBox> */}

                                  <SoftBox
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => setShowList(true)}
                                  >
                                    <img src={cross} alt="Cancel" />
                                  </SoftBox>
                                </SoftBox>

                                <SoftInput
                                  multiline
                                  rows={3}
                                  type="text"
                                  inputProps={{
                                    maxLength: "1000",
                                  }}
                                  value={fb}
                                  onChange={(e) => setFb(e.target.value)}
                                  sx={{ mb: 1 }}
                                />

                                {fb === "" ? (
                                  <SubmitButtonClose>Submit</SubmitButtonClose>
                                ) : (
                                  <SubmitButton onClick={() => SubmitFb()}>Submit</SubmitButton>
                                )}
                              </Box>
                            ) : (
                              // <Box
                              //   height="100%"
                              //   width="100%"
                              //   sx={{
                              //     display: "flex",
                              //     justifyContent: "center",
                              //     alignItems: "center",
                              //   }}
                              // >
                              //   <SoftBox
                              //     sx={{
                              //       height: "33px",
                              //       backgroundColor: "#3B5092",
                              //       borderRadius: "2px",
                              //       cursor: "pointer",
                              //     }}
                              //     display="flex"
                              //     justifyContent="center"
                              //     alignItems="center"
                              //     // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                              //     width="40px"
                              //     onClick={() => setShowList(false)}
                              //   >
                              //     <SoftBox sx={{ color: "#FFF" }}>+</SoftBox>
                              //   </SoftBox>
                              // </Box>
                              <SoftBox
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  backgroundColor: "#cce6ff94",
                                  py: 1,
                                  my: 1,
                                  border: "2px",
                                  borderStyle: "dashed",
                                  borderColor: "#a4d3d0",
                                }}
                              >
                                <SoftBox
                                  sx={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    gap: "5px",
                                  }}
                                  // onClick={() => setShowList(false)}
                                >
                                  <SoftBox
                                    sx={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                    onClick={() => setShowList(false)}
                                  >
                                    <svg
                                      width="30"
                                      height="30"
                                      viewBox="0 0 30 30"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                      <rect
                                        width="30"
                                        height="30"
                                        fill="url(#pattern0_4087_55106)"
                                      />
                                      <defs>
                                        <pattern
                                          id="pattern0_4087_55106"
                                          patternContentUnits="objectBoundingBox"
                                          width="1"
                                          height="1"
                                        >
                                          <use
                                            xlinkHref="#image0_4087_55106"
                                            transform="scale(0.0078125)"
                                          />
                                        </pattern>
                                        <image
                                          id="image0_4087_55106"
                                          width="128"
                                          height="128"
                                          xlinkHref="data:image/png;base64,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"
                                        />
                                      </defs>
                                    </svg>
                                  </SoftBox>
                                  <SoftTypography fontSize="15px" fontWeight="400">
                                    Add Suggestion
                                  </SoftTypography>
                                </SoftBox>
                              </SoftBox>
                            )}
                          </Box>
                        ) : (
                          <Box>
                            <iframe
                              // src="https://sakshamtifac.org/saksham-rojgar-sathi/"
                              src="https://sakshamtifac.org/blogs/"
                              title="Saksham Rojgar Sathi"
                              style={{
                                height: modalHeight ? "500px" : "360px",
                                width: "100%",
                                overflowX: "none",
                              }}
                            ></iframe>
                          </Box>
                        )}
                      </Box>

                      {step === 0 && data?.length !== 0 && (
                        <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                          {modalHeight ? (
                            <SoftTypography
                              fontSize="14px"
                              fontWeight="medium"
                              cursor="pointer"
                              // color="#3B5092"
                              sx={{
                                "&:hover": {
                                  cursor: "pointer",
                                },
                              }}
                              onClick={() => setModalHeight(false)}
                            >
                              <span style={{ color: "#3B5092" }}>See less</span>{" "}
                              <KeyboardArrowUpIcon fontSize="small" />
                            </SoftTypography>
                          ) : (
                            <SoftTypography
                              fontSize="14px"
                              fontWeight="medium"
                              color="#3B5092"
                              sx={{
                                "&:hover": {
                                  cursor: "pointer",
                                },
                              }}
                              onClick={() => setModalHeight(true)}
                            >
                              <span style={{ color: "#3B5092" }}>View more</span>{" "}
                              <KeyboardArrowDownIcon fontSize="small" />
                            </SoftTypography>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Menu>
                </SoftBox>
              )}

              <Button
                id="basic-button"
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{
                  background: "#FFFFFF",
                  textTransform: "none",
                  "&:hover": {
                    background: "#FFFFFF",
                  },
                }}
              >
                <Box
                  sx={{
                    width: "38px",
                    height: "38px",
                    border: "double 3px transparent",
                    borderRadius: "50%",
                    backgroundImage:
                      "linear-gradient(white, white), radial-gradient(circle at top left,#4AE27E 0%, #6563FF 50%, #1B5BFF 100%)",
                    backgroundOrigin: "border-box",
                    backgroundClip: "content-box, border-box",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "8px",
                  }}
                >
                  <img
                    src={imgNew ? imgNew : imgProfile}
                    style={{ height: "35px", width: "35px", borderRadius: "50%" }}
                  />
                </Box>

                {!matchsm && (
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "26px",
                      fontFamily: "Poppins",
                      color: "#000000",
                    }}
                  >
                    {sessionStorage.getItem("user_name")
                      ? sessionStorage.getItem("user_name")
                      : "User"}
                    &nbsp;
                  </Typography>
                )}

                <ArrowDropDownIcon fontSize="medium" sx={{ color: "#000000" }} />
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
        <Toolbar />

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 5px rgba(0,0,0,0.10))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            onClick={() => {
              navigate("/profile");
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
              <PersonOutlineIcon fontSize="medium" sx={{ color: "#000000", mr: 1 }} />
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#000000",
                }}
                l
              >
                Profile
              </Typography>
            </Box>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleClose();
              handleLogout();
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
              <LogoutIcon fontSize="medium" sx={{ color: "#000000", mr: 1 }} />
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#000000",
                }}
                l
              >
                Logout
              </Typography>
            </Box>
          </MenuItem>

          <MenuItem
            onClick={() => {
              setReset(true);
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
              <LockResetIcon fontSize="medium" sx={{ color: "#000000", mr: 1 }} />
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "26px",
                  fontFamily: "Poppins",
                  color: "#000000",
                }}
                l
              >
                Reset Password
              </Typography>
            </Box>
          </MenuItem>
        </Menu>

        {/*
      <AppBar
        position={absolute ? "absolute" : navbarType}
        sx={{ backgroundColor: "#fff", marginRight: "0px", marginLeft: "0px" }}
      // position="static" sx={{backgroundColor:'#fff'}}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters>
            <SoftBox className='col-sm-4 ' sx={{width:'124px',height:'55px',border:'1px solid'}}>
                
                Logo For Samarth
              </SoftBox>
              <SoftBox className='col-sm-4' >
                <Link to="/authentication/sign-in/basic">
                  <IconButton sx={navbarIconButton} size="small">
                    <Icon
                      sx={({ palette: { dark, white } }) => ({
                        color: light ? white.main : dark.main,
                      })}
                    >
                      account_circle
                    </Icon>
                    <SoftTypography
                      variant="button"
                      fontWeight="medium"
                      color={light ? "white" : "dark"}
                    >
                      Sign in
                    </SoftTypography>
                  </IconButton>
                </Link>
              </SoftBox>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ display: { xl: "none" }, mr: 2 }}
              onClick={handleMiniSidenav}
            >
              <MenuIcon />
            </IconButton>
            <SoftBox sx={{ flexGrow: 0.8, display: { xs: "block", md: "block" } }} py="10px">
              <img src={logo} style={{ width: "120px" }} />
              <SoftBox componenet ="img" src={logo}></SoftBox> 
            </SoftBox>
           <SoftBox display="flex" flexDirection="row" justfiyContent="flex-start">
            <SoftBox
              sx={{
                flexGrow: 0.2,
                width: "20px",
                height: "38px",
                display: { xs: "none", md: "flex" },
                flexDirection: "column",
                alignItems: "center",
                justfiyContent: "baseline",
              }}
            >
              <SoftTypography fontWeight="medium" fontSize="13px" lineHeight="17px">
                {time}
              </SoftTypography>
              <SoftTypography fontWeight="medium" fontSize="13px" lineHeight="17px">
                {days[day].substring(0, 3)} {date}
              </SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                backgroundColor: "#FF5C00",
                borderRadius: "50px",
                width: "100px",
                height: "38px",
              }}
            >
              <IconButton
                size="small"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "9px",
                  padding: "8px 10px",
                }}
                onClick={() => handleLogout()}
              >
                <Icon
                  sx={({ palette: { dark, white } }) => ({
                    color: !light ? white.main : dark.main,
                  })}
                >
                  account_circle
                </Icon>
                <SoftTypography
                  variant="button"
                  fontWeight="medium"
                  color={!light ? "white" : "dark"}
                >
                  Logout
                </SoftTypography>
              </IconButton>
            </SoftBox>
          </Toolbar>
        </Container>
      </AppBar>
    */}
      </Box>
      <Modal
        show={reset}
        onHide={() => {
          setReset(false);
        }}
        // size="lg"
        centered
        style={{ margin: "0px" }}
      >
        {/* <Modal.Header closeButton>Reset Password</Modal.Header> */}

        <Modal.Body>
          <SoftBox sx={{ m: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              {/*
              <p className="HeaderCSV">
                Reset Password
              </p>
              */}
              <SoftTypography
                sx={{
                  color: "black",
                  fontSize: "15px",
                  fontWeight: "bold",
                  lineHeight: "19px",
                }}
              >
                Reset Password
              </SoftTypography>

              <IconButton onClick={() => setReset(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <SoftTypography
                sx={{
                  color: "black",
                  fontSize: "15px",
                  fontWeight: "small",
                  lineHeight: "19px",
                }}
              >
                New Password:
              </SoftTypography>
              <SoftBox display="flex" flexDirection="row" alignItems="center">
                <SoftBox width="210px">
                  <SoftInput
                    type="password"
                    placeholder=""
                    // disabled={autopass}
                    id="password"
                    name="password"
                    onChange={registrationForm.handleChange}
                    value={registrationForm.values.password}
                  />
                  {registrationForm.touched.password && registrationForm.errors.password ? (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {registrationForm.errors.password}
                    </span>
                  ) : null}
                </SoftBox>
              </SoftBox>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <SoftTypography
                sx={{
                  color: "black",
                  fontSize: "15px",
                  fontWeight: "small",
                  lineHeight: "19px",
                }}
              >
                Confirm Password:
              </SoftTypography>
              <SoftBox display="flex" flexDirection="row" alignItems="center">
                <SoftBox width="210px">
                  <SoftInput
                    type="password"
                    placeholder=""
                    // disabled={autopass}
                    id="confirm_password"
                    name="confirm_password"
                    onChange={registrationForm.handleChange}
                    value={registrationForm.values.confirm_password}
                  />
                  {registrationForm.touched.confirm_password &&
                  registrationForm.errors.confirm_password ? (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {registrationForm.errors.confirm_password}
                    </span>
                  ) : null}
                </SoftBox>
              </SoftBox>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "40px" }}>
              <button
                className="login-btn3"
                // onClick={() => {
                //   AssignCP();
                // }}
                onClick={registrationForm.handleSubmit}
              >
                <span className="login-btn3-Text">Reset</span>
              </button>
              <button className="login-btn4" onClick={() => setReset(false)}>
                <span className="login-btn4-Text">Cancel</span>
              </button>
            </Box>
          </SoftBox>
        </Modal.Body>
      </Modal>
      <Modal
        show={show}
        onHide={() => {
          Setshow(false);
          // showAlert();
          Setshow(false);
          Setshowpassword(false);
        }}
        centered
      >
        <Modal.Header closeButton>Retrieve Password</Modal.Header>

        <Modal.Body>
          <SoftBox display="flex">
            {/* Password: {showpassword ? copyPassword.value : "**************"} */}
            Password: {showpassword ? displayPassword : "**************"}
            <SoftBox
              ml={25}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                Setshowpassword(true);
                copy(`${copyPassword.value}`);
              }}
            >
              {/* <Icon icon="mdi:content-copy" color="#3b5092" width="20" /> */}
              <ContentCopyIcon color="#3b5092" width="20" />
            </SoftBox>
          </SoftBox>
        </Modal.Body>
        <Modal.Footer>
          <SoftBox
            pl={2}
            sx={{
              height: "45px",
              backgroundColor: "#3B5092",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
            width={{ lg: "225px", sm: "100%", xs: "50%" }}
            onClick={() => downloadfile()}
          >
            <SoftTypography
              display="flex"
              justifyContent="center"
              sx={{ color: "#fff", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}
            >
              Download
            </SoftTypography>
          </SoftBox>
          <SoftBox
            pl={2}
            sx={{
              height: "45px",
              backgroundColor: "#FFFFFF",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
            width={{ lg: "225px", sm: "100%", xs: "50%" }}
            onClick={() => {
              Setshow(false);
              // showAlert();
              Setshow(false);
              Setshowpassword(false);
              handleClose();
              handleLogout();
            }}
          >
            <SoftTypography
              display="flex"
              justifyContent="center"
              sx={{ color: "#3B5092", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}
            >
              Cancel
            </SoftTypography>
          </SoftBox>
        </Modal.Footer>
      </Modal>

      <Snackbar
        open={alertshow}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        // sx={{ height: "35%" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          sx={{
            width: "100%",
            // background: "#3B5092",
            // color: "#FFFFFF",
            background: "rgb(189, 253, 200)",
            color: "rgb(4, 156, 47)",
            borderRadius: "12px",
            pt: 0.5,
            pb: 0.5,
          }}
        >
          <SoftTypography fontWeight="medium" fontSize="13px" color="#FFFFFF">
            Submitted Successfully!
          </SoftTypography>
        </Alert>
      </Snackbar>
    </>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
